import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonModule, DOCUMENT } from '@angular/common';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  readonly ApiUrl: string = environment.appUrl;
  private currentUserSubject: BehaviorSubject<any> = new BehaviorSubject({});
  private loginUser = new BehaviorSubject<boolean>(false);
  private token_checked = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
    // Add the storage event listener here in the constructor
    window.addEventListener('storage', (event) => {
      // console.log('Storage event detected:', event);  // Debugging log
      if (event.key === 'auth-event') {
        if (event.newValue === 'login') {
          // console.log('Login event detected from another tab');  // Debugging log
          const savedUser = localStorage.getItem('currentUser');
          if (savedUser) {
            // console.log('User found in localStorage:', savedUser);  // Debugging log
            this.sendCurrentUserSubject(JSON.parse(savedUser));
            this.sendLoginUser(true);
          }
        } else if (event.newValue === 'logout') {
          // console.log('Logout event detected from another tab');  // Debugging log
          this.sendCurrentUserSubject({});
          this.sendLoginUser(false);
        }
      }
    });


  }
  getSavedUser() {
    if (localStorage.getItem('currentUser')) {
      let saved_user: any = localStorage.getItem('currentUser');
      this.sendCurrentUserSubject(JSON.parse(saved_user));
      this.sendLoginUser(true);
    }
  }
  // login(postdata: {}): Observable<any> {
  //   return this.http.post<any>(`${ this.ApiUrl } / signin`, postdata)
  //     .pipe(map(user => {
  //       // store user details and jwt token in local storage to keep user logged in between page refreshes
  //       localStorage.setItem('currentUser', JSON.stringify(user));
  //       this.currentUserSubject.next(user);
  //       this.startRefreshTokenTimer();
  //       return user;
  //     }));
  // }
  login(postdata: {}): Observable<any> {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/auth-login`, postdata).pipe(
      map(res => {
        const user = res.data || res;
        // Normalize userid/id
        if (user.id && !user.userid) user.userid = user.id;

        // Store user details and token in localStorage
        localStorage.setItem('currentUser', JSON.stringify(user));

        // Broadcast login event
        localStorage.setItem('auth-event', 'login');  // Notify other tabs

        this.sendCurrentUserSubject(user);
        this.sendLoginUser(true);
        this.startRefreshTokenTimer();
        return user;
      })
    );
  }

  user_login(postdata: {}): Observable<any> {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/auth-login`, postdata)
      .pipe(map(res => {
        const user = res.data || res;
        // Normalize userid/id
        if (user.id && !user.userid) user.userid = user.id;

        localStorage.setItem('currentUser', JSON.stringify(user));
        this.sendCurrentUserSubject(user);
        this.sendLoginUser(true);
        this.startRefreshTokenTimer();
        return user;
      }));
  }

  auto_login(accesskey: {}): Observable<any> {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/auto_login`, accesskey)
      .pipe(map(res => {
        const user = res.data || res;
        if (user.id && !user.userid) user.userid = user.id;
        if (user.userId && !user.userid) user.userid = user.userId;

        localStorage.setItem('currentUser', JSON.stringify(user));
        this.sendCurrentUserSubject(user);
        this.sendLoginUser(true);
        this.startRefreshTokenTimer();
        return user;
      }));
  }
  auto_login2(accesskey: {}): Observable<any> {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/auto-login`, { accesskey })
      .pipe(map(res => {
        const user = res.data || res;
        if (user.id && !user.userid) user.userid = user.id;
        if (user.userId && !user.userid) user.userid = user.userId;

        localStorage.setItem('currentUser', JSON.stringify(user));
        this.sendCurrentUserSubject(user);
        this.sendLoginUser(true);
        this.startRefreshTokenTimer();
        return user;
      }));
  }

  // logout() {
  //   // remove user from local storage and set current user to null
  //   localStorage.removeItem('currentUser');
  //   this.sendCurrentUserSubject({});
  //   this.sendLoginUser(false);
  // }
  logout() {
    // Remove the user from localStorage
    localStorage.removeItem('currentUser');

    // Broadcast logout event
    localStorage.setItem('auth-event', 'logout'); // Notify other tabs

    this.currentUserSubject.next({});
    this.sendLoginUser(false);
  }

  refreshToken() {
    let currentuser = localStorage.getItem('currentUser');
    let var_userid = 0;
    let email = '';
    if (currentuser) {
      let userdata = JSON.parse(currentuser);
      var_userid = userdata.userid;
      email = userdata.email;
    }
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/refresh-token`, { userid: var_userid, email: email })
      .pipe(map((res) => {
        const user = res.data || res;
        // Normalize userid/id
        if (user.id && !user.userid) user.userid = user.id;

        localStorage.setItem('currentUser', JSON.stringify(user));
        this.sendCurrentUserSubject(user);
        this.sendLoginUser(true);
        this.startRefreshTokenTimer();
        return user;
      }));
  }

  getUserPrivilege(postdata: {}) {
    return this.http.post(this.ApiUrl + '/usermaster_manage', postdata);
  }

  // helper methods

  private refreshTokenTimeout: any;

  private startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    // const jwtToken = JSON.parse(atob(this.currentUserValue.token.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    // const expires = new Date(jwtToken.exp * 1000);
    // const timeout = expires.getTime() - Date.now() - (60 * 1000);
    // this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }

  sendLoginUser(data: any) {
    this.loginUser.next(data);
  }

  getLoginUser() {
    return this.loginUser.asObservable();
  }

  sendCurrentUserSubject(data: any) {
    this.currentUserSubject.next(data);
  }

  getCurrentUserSubject() {
    return this.currentUserSubject.asObservable();
  }

  sendTokenChecked(data: any) {
    this.token_checked.next(data);
  }

  getTokenChecked() {
    return this.token_checked.asObservable();
  }
}
